import React, { useState } from "react";
import "./Cancelled_Ordered_Card.css";
import { Row, Col } from "react-bootstrap";
import { encodeId, formatDate } from "../../../utils/common";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import Green_btn from "../common_btn/green_btn/Green_btn";
import OrderTrackModal from "../common_modal/order_track_modal/OrderTrackModal";
import { useNavigate } from "react-router-dom";

const Cancelled_Ordered_Card = ({
  data,
  showTrackOrder = true,
  track_order_text,
  baseLike,
  type,
  onOpenOrderDetails,

  showStatus = true,
  showPrice = true,
  showDate = true,
  showView = true,
  showButton = true,
}) => {
  const [showCouponModal, setShowCouponModal] = useState(false);

  const router = useNavigate();

  const productList = data || [];
  const product = productList[0];

  const handleTrackOrder = () => {
    if (type === "Ordered") {
      setShowCouponModal(data);
    } else if (type === "Return") {
      // router.push(`/return-order-details/${encodeId(data?.id)}`);
    }
  };

  const OpenInvoice = (invoice) => {
    window.open(
      `${process.env.REACT_APP_IMG_URL}${invoice}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <>
      <section className="Cancelled_Ordered_Card">
        {/* Desktop View */}
        <div className="main_card desktop_view">
          <Row className="align-items-center justify-content-between g-3 p-2 w-100">
            {/* Product */}
            <Col lg={3} md={3} sm={12} className="m-0">
              <div className="product_section">
                <div className="product_info">
                  <p className="product_name">
                    Order Number #{data?.Product_Order?.invoice_no || ""}
                  </p>
                </div>

                <div className="product_info">
                  <p className="product_name">
                    No of Items : {data?.quantity || "0"}
                  </p>
                </div>
              </div>
            </Col>

            {/* Status */}
            {showStatus && (
              <Col lg={2} md={2} sm={6} className="m-0">
                <p
                  className={`status_text ${
                    type === "Return"
                      ? "return_status"
                      : data?.status === "Delivered"
                      ? "shipped_status"
                      : "delivery_status"
                  }`}
                >
                  Cancelled
                </p>
              </Col>
            )}

            {/* Price */}
            {showPrice && (
              <Col lg={2} md={2} sm={6} className="m-0">
                <p className="price_text">
                  ₹{Number(data?.total_amount || 0).toFixed(0)}
                </p>
              </Col>
            )}

            {/* Date */}
            {showDate && (
              <Col lg={2} md={2} sm={6} className="m-0">
                <p className="date_text">{formatDate(data?.updatedAt)}</p>
              </Col>
            )}

            {/* Actions */}
            {(showView || showButton) && (
              <Col lg={3} md={3} sm={6} className="m-0">
                <div className="action_section">
                  {showView && (
                    // <Link href={baseLike} className="eye_link">
                    //   <FontAwesomeIcon icon={faEye} style={{ color: "#000" }} />
                    // </Link>

                    <div
                      className="eye_link"
                      onClick={() => {
                        onOpenOrderDetails({
                          id: data?.id,
                          order_status_id: data?.order_status_id,
                        });
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faEye}
                        style={{ color: "#000", cursor: "pointer" }}
                      />
                    </div>
                  )}

                  {/* {showTrackOrder && showButton && (
                    <Green_btn
                      btnText={track_order_text}
                      onClick={handleTrackOrder}
                    />
                  )} */}
                  {/* {data?.invoice && (
                    <Green_btn
                      btnText="Invoice"
                      onClick={() => OpenInvoice(data?.invoice)}
                    />
                  )} */}
                </div>
              </Col>
            )}
          </Row>
        </div>

        {/* Mobile View */}
        <div className="main_card mobile_view">
          <div className="card_top_div">
            <div className="product_section">
              <div className="product_info">
                <p className="product_name">
                  Order Number #{data?.Product_Order?.invoice_no || ""}
                </p>
              </div>

              <div className="product_info">
                <p className="product_name">
                  No of Items : {data?.quantity || "0"}
                </p>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="right_side">
              {showStatus && (
                <p
                  className={`status_text ${
                    type === "Return"
                      ? "return_status"
                      : data?.Product_Order?.status === "Delivered"
                      ? "shipped_status"
                      : "delivery_status"
                  }`}
                >
                  Cancelled
                </p>
              )}{" "}
              {showDate && (
                <p className="date_text">{formatDate(data?.updatedAt)}</p>
              )}
            </div>
          </div>{" "}
          <div className="price_action_row">
            {showPrice && (
              <p className="price_text">
                ₹{Number(data?.total_amount || 0).toFixed(0)}
              </p>
            )}

            {(showView || showButton) && (
              <div className="card_last_div">
                {showView && (
                  <div
                    className="eye_link"
                    onClick={() =>
                      onOpenOrderDetails({
                        id: data?.id,
                        order_status_id: data?.order_status_id,
                      })
                    }
                  >
                    <FontAwesomeIcon
                      icon={faEye}
                      style={{ color: "#000", cursor: "pointer" }}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      <OrderTrackModal
        order={showCouponModal}
        show={showCouponModal}
        onHide={() => setShowCouponModal(false)}
      />
    </>
  );
};

export default Cancelled_Ordered_Card;
